import './index.scss';

import React from 'react';
import Config from '../../config';
import SmileImage from '../../../public/images/smile.svg'

export default class extends React.Component {

  state = {
    website: ''
  };

  constructor() {
    super();

    this.state.website = Config.getWebsite();
  }

  render() {
    return (
      <div className="content-inner-container bad-times-thank-you">
        <div className="bad-times-thank-you-inner">
          <img src={SmileImage}/>
          {/* <i className="fa fa-smile-o" /> */}
          <p className="title">
            <strong>Thanks for your feedback</strong>
          </p>
          <p>
            We really appreciate any feedback we get from our customers, good or bad.
          </p>
          <div className="submit-holder">
            <a href={this.state.website} className="button">
              Visit our website
            </a>
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/states/bad-times-thanks/index.js